import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import { saveRecord } from 'tio-data/requests/save-record';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { PslfProfileExtension as PslfProfileModel } from 'tio-data/data/resources/pslf-profile.ext';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedAdminPslfSignRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { currentEmployee } = this.sessionContext;

    const { content } = (await this.store.request(
      findRecord<EmployeeModel>('employee', currentEmployee.id || '', {
        include: 'pslf-profile',
        reload: true,
      })
    )) as { content: { data: EmployeeModel } };
    const employee = content.data;

    let profile = employee.pslfProfile;
    if (!profile) {
      profile = this.store.createRecord<PslfProfileModel>('pslf-profile', {
        employee,
      });
      await saveRecord(this.store, profile);
    }

    return employee;
  }
}
